// extracted by mini-css-extract-plugin
export default {"card":"cardsteppath_card__EYbC2","logoPartner":"cardsteppath_logoPartner__VQM6C","content":"cardsteppath_content__DDnBS"};